var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSocialMnd = function SvgSocialMnd(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11697_1407)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9998 1H3.99976C2.3429 1 0.999756 2.34315 0.999756 4V20C0.999756 21.6569 2.3429 23 3.99976 23H19.9998C21.6566 23 22.9998 21.6569 22.9998 20V4C22.9998 2.34315 21.6566 1 19.9998 1ZM3.99976 0C1.79062 0 -0.000244141 1.79086 -0.000244141 4V20C-0.000244141 22.2091 1.79062 24 3.99976 24H19.9998C22.2089 24 23.9998 22.2091 23.9998 20V4C23.9998 1.79086 22.2089 0 19.9998 0H3.99976Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98449 16V11.5176C7.98449 10.5232 8.65625 9.81076 9.52647 9.81076C10.4425 9.81076 11.0227 10.4193 11.0227 11.3692V16H13.0074V11.5325C13.0074 10.4787 13.6486 9.81076 14.5646 9.81076C15.4959 9.81076 16.015 10.4193 16.015 11.4879V16H17.9998V10.82C17.9998 9.98887 17.7249 9.30612 17.1906 8.78664C16.6562 8.26716 15.9387 8 15.0685 8C14.015 8 13.2211 8.40074 12.6868 9.18738H12.5646C12.0914 8.43043 11.2669 8 10.183 8C9.16006 8 8.38144 8.4898 7.99976 9.14286H7.89289V8.19295H5.99976V16H7.98449Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11697_1407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(-0.000244141)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSocialMnd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/social-mnd.809468490e0b0a2f62c702a260f81b5f.svg";